import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
// import * as CryptoJS from 'crypto-js';
import { SHA256, WordArray } from 'crypto-js';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgxUiLoaderService } from 'ngx-ui-loader';

@Injectable({
  providedIn: 'root'
})
export class TokenInterceptorService implements HttpInterceptor {
  public encryptInfo;
  public decryptedInfo;


  storageData = { "status": "ERROR", "subCode": "400", "message": "Transfer Id already exists" };

  hash(message: any): WordArray {
    return SHA256(message);
  }

  intercept(req, next) {
    this._loader.start();

    // console.log('encript string:::', this.hash(req.body).toString());


    //Encrypt Info
    // this.encryptInfo = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(this.storageData), 'ABCDEFGHIJKLMNOP').toString());

    // console.log('encryptInfo', this.encryptInfo);


    //Decrypt Info
    // var deData = CryptoJS.AES.decrypt(decodeURIComponent(this.encryptInfo), 'ABCDEFGHIJKLMNOP');
    // this.decryptedInfo = JSON.parse(deData.toString(CryptoJS.enc.Utf8));

    // console.log('decryptedInfo', this.decryptedInfo);
    // console.log('req is::', req);
    // if(req.url.includes('https://ymapi.mykumpany.com/AllianceWallet-2.1.1.RELEASE')){
    // console.log('request is mtched now', req.body);
    // }


    let tokenizedReq = req.clone({});

    // if(localStorage.currentUser){
    //   let token = JSON.parse(localStorage.currentUser)?.data
    //   token =  token?.walletToken;
    //   tokenizedReq = req.clone({
    //     setHeaders : {
    //       "authToken": token
    //     }
    //   });
    // }


    return next.handle(tokenizedReq).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this._loader.stop();
          if (event.body.status_code == 0) {
            // this.snackBar.open(event.body.error.message, event.body.error.error_code, {
            //   duration: 3000
            // });
          
            if (event.body.error.error_code == 'YM-RET-406' && event.body.error.message == 'Session Expired. Please Login Again. YM' || event.body.error.error_code == 'YM-DIS-BAL-4001' && event.body.error.message == 'Invalid User Authentication') {
              localStorage.clear();
              this.route.navigate(['']);
            }else if(event.body.error.error_code == 'YM-DMT-4008' && event.body.error.message =='Invalid User Authentication. YM' ){
              localStorage.clear();
              this.route.navigate(['']);
            }

          } else if (event.body.status_code == 1) {
            // this.snackBar.open(event.body.message, event.body.status, {
            //   duration: 3000
            // });
          }
          // console.log('event.body in interceptor:::', event.body);
        }
        return event;
      }));
  }
  constructor(private snackBar: MatSnackBar,    private spinner: NgxSpinnerService,
    private route: Router, private toastr: ToastrService, private _loader: NgxUiLoaderService,    ) { }

  // fetchWalletBalance() {
  //   this.authService.getRetailerWalletBalance().subscribe(res=>{
  //     this.walletAmount = res;
  //   });
  // }
}
